import contiSilent from '../../../Assets/technical_info/contiSilent.jpg'

const TechnicalLV12 = () => {
    return (
        <div>
            <p><span style={ { fontSize: "24px" } }><strong>ContiSilent</strong></span></p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<strong>ContiSilent&trade;</strong> ir uzņēmuma <strong>Continental</strong> radīta tehnoloģija, ar kuras palīdzību ir iespējams samazināt riepu rites troksni.</p>

            <p>&nbsp;</p>

            <p><span style={ { fontSize: "24px" } }><strong>Tehnoloģija</strong></span></p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<strong>ContiSilent</strong> ir veidota tā, lai samazinātu trokšņu līmeni automobiļa salonā uz visa veida ceļa segumiem. Riepas, kas ir izgatavotas ar <strong>ContiSilent&trade;</strong> tehnoloģiju, iekšpusē ir aprīkotas ar trokšņu slāpētāju no poliuretāna putām. Slāpētājs tiek pielīmēts pie riepas iekšējā slāņa protektora daļā. Neskatoties uz temperatūras izmaiņām, trokšņu slāpētāja struktūra paliek neskarta.</p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Šī principa pamatā ir riepas iekšējo trokšņu slāpēšana, kas rodas no riepas rites un kas caur riteņa disku, riteņa rumbu un balstiekārtas elementiem tiek novadīti uz automobiļa virsbūvi un līdz ar to arī uz automobiļa salonu.</p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<strong>ContiSilent&trade;</strong> tehnoloģija palīdz samazināt troksni automobiļa salonā līdz pat 9 dB (A), atkarībā no automobiļa veida, tā ātruma un ceļa seguma. Šobrīd gan tā ir pieejama tikai vasaras riepām, bet <strong>ContiSilent</strong> riepas ir salāgojamas ar standarta diskiem. Braukšanas īpašības (veiktspēju) tā neietekmē, tāpat nav arī negatīvas ietekmes uz nodilumizturību (t.i. noskrējienu) un ātruma/nestspējas īpašībām. Tiek rekomendēts izmantot šādas riepas visiem četriem riteņiem.</p>

            <p>&nbsp;</p>

            <p><span style={ { fontSize: "24px" } }><strong>Atpazīšana</strong></span></p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Riepas ar <strong>ContiSilent&trade;</strong> tehnoloģiju var atpazīt pēc marķējuma uz riepas sāniem:</p>

            <p>&nbsp;</p>

            <p><img alt="ContiSilent" src={contiSilent} style={ { width: "min(100%, 400px)", height: "auto", display: "block", margin: "auto" } } /></p>

            <p>&nbsp;</p>

            <p><span style={ { fontSize: "24px" } }><strong>Ieguvumi</strong></span></p>

            <p>&nbsp;</p>

            <ul>
                <li>Samazināts trokšņu līmenis automobiļa salonā uz visa veida ceļa segumiem</li>
                <li><strong>ContiSilent&trade;</strong> darbojas visos laika apstākļos</li>
                <li>Nekādu izmaiņu riepu veiktspējā</li>
                <li>Neietekmē negatīvi noskrējienu un ātruma/nestspējas īpašības</li>
                <li>Tāda pati montēšana un uzglabāšana kā standarta riepām</li>
            </ul>
        </div>
    );
};

export default TechnicalLV12;


